import { useOnboardingStatus } from '../queries/onboarding';

/**
 * Returns whether the user must complete onboarding before using the app.
 * null = still loading.
 */
export const useOnboardingGate = (enabled: boolean): boolean | null => {
  const { data, isPending } = useOnboardingStatus({ enabled });

  if (!enabled) return false;
  if (isPending) return null;
  return data ? !data.isComplete : false;
};
